import axios from "axios";
import { joinURLs } from "../utils/urlUtil";
import { getHeadersConfig } from "../utils/config";
import { DemandSourcesResponseDto } from "../utils/types";
import { ResponseStatus } from "../utils/types";
import { Dispatch, SetStateAction } from "react";
import ErrorHandler from "../utils/ErrorHandler";

export const DemandSources = {
  getDemandSources: async (getDemandSourcesAbortController: AbortController, setDemandSourcesResponseDto?: Dispatch<SetStateAction<DemandSourcesResponseDto | null>>) => {
    const url = joinURLs("2/dashboard/demandSources", process.env.REACT_APP_REPORTING_API_BASE_URL);

    if (setDemandSourcesResponseDto) {
      setDemandSourcesResponseDto({
        status: ResponseStatus.LOADING,
        error: null,
        demandSourcesResponse: null,
      });
    }

    try {
      const response = await axios.get(url, {
        ...getHeadersConfig(),
        withCredentials: true,
        signal: getDemandSourcesAbortController.signal
      });
      if (response) {
        if (setDemandSourcesResponseDto) {
          setDemandSourcesResponseDto({
            status: ResponseStatus.OK, 
            error: null,
            demandSourcesResponse: response.data.demandSources,
          });
        }
        return response.data.demandSources;
      }
    } catch (error:any) {
      // handle error
      console.log(error);

      if (!axios.isCancel(error)) {
        const isLoggedOut = ErrorHandler.handleAuthError(error);
        if (!isLoggedOut) {
          const responseDto: DemandSourcesResponseDto = {
            status: ResponseStatus.ERROR, 
            error: error?.response?.data?.errorMessage || error?.message,
            demandSourcesResponse: null
          };
          if (setDemandSourcesResponseDto) {
            setDemandSourcesResponseDto(responseDto);
          }
        }
      }
    }
  }
}